import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatSelectModule } from '@angular/material/select';
import { WishlistService } from '../../services/raintree/Transmission/wishlist.service';
import { ActivatedRoute, Params } from '@angular/router';
import { VisitTransmissionService } from '../../services/raintree/Transmission/visit-transmission.service';
import { FormsModule } from '@angular/forms';
import { WishlistResponseObj } from '../../services/raintree/interfaces/wishlist.interface';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LoaderComponent } from '../../common-component/loader/loader.component';

@Component({
  selector: 'app-visited-filter-dialog',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    MatSelectModule,
    MatAutocompleteModule,
    LoaderComponent
  ],
  templateUrl: './visited-filter-dialog.component.html',
  styleUrl: './visited-filter-dialog.component.scss'
})
export class VisitedFilterDialogComponent {

  loading=false;
  queryParams:Params;
  appliedFilters={
    memName:'',//addedToWishlist
    address:'',
    userId:-1,//visited
    wishlistId:-1,
    feedbackCategoryId:-1,//visited
  }

  feedbackError=false;
  feedbackList=[{
    feedbackCd:-1,
    feedbackMsg:''
  }]

  wishlistError=false;
  wishlistInput:string='';
  wishlistNames:WishlistResponseObj[]=[];
  filteredWishlist:WishlistResponseObj[]=[];

  userlistError=false;
  userList:any[]=[];
  filteredUserlist:any[]=[];
  userNameInput:string='';

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: {activeView: number},
    @Inject(MatDialogRef<VisitedFilterDialogComponent>) public dialogRef:MatDialogRef<VisitedFilterDialogComponent>,
    private _route:ActivatedRoute,
    private _wishlictService:WishlistService,
    private _visitTransmission:VisitTransmissionService
  ){
    this.queryParams=_route.snapshot.queryParams;
  }

  ngOnInit(){
    this.loading=true;
    this.getCategories();
    // this.getWishlistNames();
    // this.getVisitedUsers();
  }

  getCategories(){
    this._visitTransmission.fetchCategories({uiDistrict: this.queryParams['district'],uiState: this.queryParams['state']}).subscribe({
      next: (response)=>{
        // console.log('filter categories respponse->',response);
        
        if(response.error){
          this.feedbackError=true;
          this.feedbackList=[{feedbackCd:-1,feedbackMsg:response.message}];
          this.getWishlistNames();
        }
        else{
          this.feedbackError=false;
          this.feedbackList=response.data;
          this.getWishlistNames();
        }
      },
      error: (err)=>{
        this.feedbackError=true;
        this.feedbackList=[{feedbackCd:-1,feedbackMsg:err}];
        this.getWishlistNames();
      }
    });
  }

  getWishlistNames(){

    this._wishlictService.fetchWishlistsName({
      pincode: this.queryParams['pincode'], 
      uiDistrict: this.queryParams['district'], 
      uiState: this.queryParams['state'],
      pageNo: 1,
      pageLimit: 10000
    },
  ).subscribe({
        next:(response)=>{
          // console.log(response);

          if(response.error){
            this.wishlistError=true;
            this.wishlistNames=[{id:-1,title: response.message,createdDate:''}];
            this.filteredWishlist=this.wishlistNames;
            this.getVisitedUsers();
          }
          else{
            this.wishlistError=false;
            this.wishlistNames=response.data;
            this.filteredWishlist=this.wishlistNames;
            this.getVisitedUsers();
          }
        },
        error: (err)=>{
          this.wishlistError=true;
          this.wishlistNames=[{id:-1,title: err,createdDate:''}];
          this.filteredWishlist=this.wishlistNames;
          this.getVisitedUsers();
        }
      });
  }
  filterWishlistNames(){
    this.filteredWishlist=this.wishlistNames.filter((item)=>item.title.toUpperCase().includes(this.wishlistInput.toUpperCase()));
  }

  getVisitedUsers(){
    // console.log('inside getvisitedUsers');
    
    this._visitTransmission.fetchVisitedUsers({
      pincode: this.queryParams['pincode'], 
      uiDistrict:this.queryParams['district'],
      uiState:this.queryParams['state']
    }).subscribe({
      next:(response)=>{
        console.log('visitedUsers response->',response);
        
        if(response.error){
          this.userList=[];
          this.filteredUserlist=this.userList;
          this.loading=false;
        }
        else{
          this.userList=response.data;
          this.filteredUserlist=this.userList;
          this.loading=false;
        }
      },
      error: (err)=>{
        this.userList=[];
        this.filteredUserlist=this.userList;
        this.loading=false;
      }
    })
  }
  filterUserName(){
    this.filteredUserlist=this.userList.filter((user)=>user.userName.toUpperCase().includes(this.userNameInput.toUpperCase()));
  }

  applyFilter(){
    // console.log(Object.fromEntries(Object.entries(this.appliedFilters).filter((item)=>item[1]!==-1)));item
    let filters=Object.fromEntries(Object.entries(this.appliedFilters).filter(([key,value])=>value!==-1&&value!==''));
    this.dialogRef.close(filters);
  }
}
